<template>
  <div class="bill-info">
    <div class="bill-info-row">
      <div class="bill-info-label">
        {{ $t('bill-view.bill.created-at') }}
      </div>
      <div class="bill-info-value">
        {{ bill.createdAtDateTime }}
      </div>
    </div>
    <div class="bill-info-row">
      <div class="bill-info-label">
        {{ $t('bill-view.bill.client') }}
      </div>
      <div class="bill-info-value">
        {{ bill.payerFullName }}
      </div>
    </div>
    <hide-by-access action="read" data="bills-recipient_info_hide">
      <div class="bill-info-row">
        <div class="bill-info-label">
          {{ $t('bill-view.bill.phone-email') }}
        </div>
        <div class="bill-info-value">
          {{ bill.phoneEmail }}
        </div>
      </div>
    </hide-by-access>
    <div class="bill-info-row">
      <div class="bill-info-label">
        {{ $t('bill-view.bill.sum') }}
      </div>
      <div class="bill-info-value">{{ bill.sum }} {{ bill.currencyPlain }}</div>
    </div>
    <div class="bill-info-row">
      <div class="bill-info-label">
        {{ $t('bill-view.bill.purpose') }}
      </div>
      <div class="bill-info-value">
        {{ bill.purpose }}
      </div>
    </div>
    <div class="bill-info-row">
      <div class="bill-info-label">
        {{ $t('bill-view.bill.exp-at') }}
      </div>
      <div class="bill-info-value">
        {{ bill.expAt }}
      </div>
    </div>
    <div class="bill-info-row">
      <div class="bill-info-label">
        {{ $t('bill-view.bill.status') }}
      </div>
      <div class="bill-info-value">
        <transaction-status
          :status-id="bill.operationStatus"
        ></transaction-status>
      </div>
    </div>
    <div class="bill-info-row">
      <div class="bill-info-label">
        {{ $t('bill-view.bill.comment') }}
      </div>
      <div class="bill-info-value">
        {{ bill.comment }}
      </div>
    </div>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import { Bill } from '@js-app/entities/Bill'
import TransactionStatus from '@vue-app/components/transaction/TransactionStatus.vue'
import HideByAccess from '@vue-app/components/base/role-based/HideByAccess.vue'

export default {
  name: 'BillCanceledDetails',
  components: { HideByAccess, TransactionStatus },
  props: {
    bill: {
      type: Bill,
    },
  },
  computed: {},
  methods: {
    async copyBillLink() {
      try {
        await navigator.clipboard.writeText(this.bill.link)
        //TODO: replace with correct notification
        $emit(this, 'linkCopied')
      } catch (err) {
        console.error('Failed to copy: ', err)
      }
    },
  },
  emits: ['linkCopied'],
}
</script>

<style lang="scss" scoped>
@import '@css-app/bill-details';
</style>
